var $ = jQuery

export default function subNavigation() {
	const links = document.querySelectorAll('.mtt-subnavigation a')

    if (links.length) {
        for (let i = 0; i < links.length; i++) {
            const link = links[i];

            const linkScroll = new LinkScroll(link)
            linkScroll.init()
        }
    }
}

class LinkScroll {
    constructor(link) {
        this.link = link

        this.init = () => {
            this.addScroll()    
        }   
    }

    addScroll() {
        this.link.addEventListener('click', (e) => {

            if(this.link.href.indexOf("#") !== -1) {
                e.preventDefault()
                const id = this.link.href.split('#')[1]
                const el = document.querySelector(`#${id}`)

                if (el) {
                    $('html, body').animate({
                        scrollTop: $(el).offset().top - 100
                    }, 500);
                }
            }
        })
    }
}